/** @format */
import React from 'react';
import PropTypes from 'prop-types';

const RenewalCalendarIcon = ({ 
  className = "h-7 w-7", 
  urgentCount = 0,
  upcomingCount = 0,
  showPinkAccent = false 
}) => {
  // Total count for badge display
  const totalCount = urgentCount + upcomingCount;
  
  return (
    <div className="relative">
      <svg 
        className={className} 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Renewal calendar icon"
      >
        {/* Clean calendar base */}
        <rect 
          x="3" 
          y="4" 
          width="18" 
          height="18" 
          rx="2" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none"
        />
        
        {/* Calendar header line */}
        <path 
          d="M3 10h18" 
          stroke="currentColor" 
          strokeWidth="1.5"
        />
        
        {/* Calendar binding rings */}
        <path 
          d="M8 2v4M16 2v4" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round"
        />
        
        {/* Minimal grid lines for calendar structure */}
        <g opacity="0.3">
          <path d="M8 10v12" stroke="currentColor" strokeWidth="0.5" />
          <path d="M13 10v12" stroke="currentColor" strokeWidth="0.5" />
          <path d="M18 10v12" stroke="currentColor" strokeWidth="0.5" />
          <path d="M3 14h18" stroke="currentColor" strokeWidth="0.5" />  
          <path d="M3 18h18" stroke="currentColor" strokeWidth="0.5" />
        </g>
        
        {/* Simple renewal indicator - circular arrow in corner */}
        {totalCount > 0 && (
          <g transform="translate(16, 16)" opacity="0.7">
            <path
              d="M2 0 A2 2 0 1 1 0 2"
              stroke="currentColor"
              strokeWidth="1"
              fill="none"
              strokeLinecap="round"
            />
            <path
              d="M1.5 -0.5 L2 0 L1.5 0.5"
              stroke="currentColor"
              strokeWidth="1"
              fill="none"
              strokeLinecap="round"
            />
          </g>
        )}
      </svg>
      
      {/* Count badge overlay - moved from complex internal elements */}
      {totalCount > 0 && (
        <div className="absolute -top-1 -right-1 bg-primary text-white text-xs font-montserrat-medium rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
          {Math.min(totalCount, 99)}
        </div>
      )}
    </div>
  );
};

RenewalCalendarIcon.propTypes = {
  className: PropTypes.string,
  urgentCount: PropTypes.number,
  upcomingCount: PropTypes.number,
  showPinkAccent: PropTypes.bool,
};

export default RenewalCalendarIcon;